<template>
  <div>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
        <button
            type="button"
            class="btn btn-success btn-with-shadow mb-2"
            data-toggle="modal"
            @click.prevent="openTab(`/common/pdf/generateProform?proformId=${proformGeneratedId.toString()}&anex=${hasAnnexes.toString()}`)"
        >
          Descargar proforma
        </button>
        <button
            type="button"
            class="btn btn-primary btn-with-shadow mb-2"
            data-toggle="modal"
            @click="openAddObsModal"
        >
          Añadir observación
        </button>
        <button
            type="button"
            class="btn btn-primary btn-with-shadow mb-2"
            data-toggle="modal"
            @click="openAddEditModal"
        >
          Añadir item
        </button>
      </div>
    </div>
  </div>

 <app-table :id="tableId" :options="options" @action="getListAction"/>

    <div class="row mt-2">
      <div class="col-sm-12 col-md-12">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <h4>Total: {{totalProform}}</h4>
        </div>
      </div>
    </div>


   <proform-detail-modal
       v-if="isAddEditModalActive"
       :table-id="tableId"
       :selected-url="selectedUrl"
       @close-modal="closeAddEditModal"
       modalTitle="Añadir item"
       editModalTitle="Editar item"
       :proformGeneratedId="proformGeneratedId"
   />

   <proform-observation-modal
       v-if="isAddObsModalActive"
       :table-id="tableId"
       :selected-url="selectedUrl"
       @close-modal="closeAddObsModal"
       modalTitle="Añadir Observación"
       editModalTitle="Añadir Observación"
       :proformGeneratedId="proformGeneratedId"
   />

    <app-confirmation-modal
        v-if="deleteConfirmationModalActive"
        modal-id="modal-delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este registro?"
    />

  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../../apiUrl";
import {TableHelpers} from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  props: {
    proformGeneratedId: String,
    total: Number
  },
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      isAddObsModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "proform-detail-table",
      rowData: {},
      options: {
        name: "proform-detail-table",
        url: `${actions.TREASURY_PROFORMA}/attachProforma/rate/proformGenerared/details/`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "proform-detail-modal",
            modalId: "proform-detail-modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "proform-detail-modal",
            modalId: "proform-detail-modal",
          }
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
        datatableWrapper: false
      }
    }
  },
  computed: {
    totalProform() {
      const total = this.$store.state.treasury.proformTotal;
      return total.toLocaleString(
          'en-US',
          {style: 'currency',currency: 'USD', minimumFractionDigits: 2})
    },
    hasAnnexes(){
      return this.$store.state.treasury.hasAnnexes;
    }
    },
    created() {
      this.options.columns = [...this.tableColumns, this.actionObj];
      this.options.url = this.options.url + this.proformGeneratedId;
    },

    methods: {
      openTab(path) {
        window.open(path, "_blank").focus();
      },
      getListAction(rowData, actionObj, active) {
        this.rowData = rowData;
        if (actionObj.title == this.$t("delete")) {
          this.openDeleteModal();
        } else if (actionObj.title == this.$t("edit")) {
          this.selectedUrl = `${actions.TREASURY_PROFORMA}/attachProforma/rate/proformGenerared/details/${this.rowData.id}/one`;
          this.openAddEditModal();
        }
      },
      openAddEditModal() {
        this.isAddEditModalActive = true;
      },
      closeAddEditModal() {
        $("#proform-detail-modal").modal("hide");
        this.isAddEditModalActive = false;
        this.deleteLoader = false;
        this.reSetData();
      },
      openAddObsModal() {
        this.isAddObsModalActive = true;
      },
      closeAddObsModal() {
        $("#proform-observation-modal").modal("hide");
        this.isAddObsModalActive = false;
        this.deleteLoader = false;
        this.reSetData();
      },
      openDeleteModal() {
        this.deleteConfirmationModalActive = true;
      },
      confirmed() {
        let url = `${actions.TREASURY_PROFORMA}/attachProforma/rate/proformGenerared/details/${this.rowData.id}`;
        this.deleteLoader = true;
        this.axiosDelete(url)
            .then((response) => {
              this.deleteLoader = false;
              $("#modal-delete").modal("hide");
              this.cancelled();
              this.$toastr.s(this.$t("deleted_success"));
              if (response.data.proformTotal || response.data.proformTotal == 0){
                this.$store.commit('updateProformTotal', response.data.proformTotal);
              }
            })
            .catch(({error}) => {
            })
            .finally(() => {
              this.$hub.$emit("reload-" + this.tableId);
            });
      },
      cancelled() {
        this.deleteConfirmationModalActive = false;
        this.reSetData();
      },
      reSetData() {
        this.rowData = {};
        this.selectedUrl = "";
      },
      afterSuccess(response) {

      }
    },

  }
</script>
